import { DondeInsertar } from "../enums/helpers-enum";

export class DatosAprobador {
    private idOrganizacionCompra: number;
    private idDocumento: number;
    private comentario: string;
    private dondeInsertar: DondeInsertar;
    private idUsuarioAprobador: string;

    constructor(idOrganizacionCompra: number, idDocumento: number, comentario: string, dondeInsertar: DondeInsertar, idUsuarioAprobador: string) {
        this.idOrganizacionCompra = idOrganizacionCompra;
        this.idDocumento = idDocumento;
        this.comentario = comentario;
        this.dondeInsertar = dondeInsertar;
        this.idUsuarioAprobador = idUsuarioAprobador;
    }

    get _idOrganizacionCompra(): number {
        return this.idOrganizacionCompra;
    }

    get _idDocumento(): number {
        return this.idDocumento;
    }

    get _comentario(): string {
        return this.comentario;
    }

    get _dondeInsertar(): DondeInsertar {
        return this.dondeInsertar;
    }

    get _idUsuarioAprobador(): string {
        return this.idUsuarioAprobador;
    }

    set _idOrganizacionCompra(value: number) {
        this.idOrganizacionCompra = value;
    }

    set _idDocumento(value: number) {
        this.idDocumento = value;
    }

    set _comentario(value: string) {
        this.comentario = value;
    }

    set _dondeInsertar(value: DondeInsertar) {
        this.dondeInsertar = value;
    }

    set _idUsuarioAprobador(value: string) {
        this.idUsuarioAprobador = value;
    }
}